import {BaseModel} from '../../_base/crud';

export class AssetClassDefaultAssumptionModel extends BaseModel {
    id: number;
    asset_class_id: number;
    default_assumption_id: number;
    default_assumption_name: string;
    name: string;

    created_at: Date;
    updated_at: Date;

    clear() {
        this.id = undefined;
        this.asset_class_id = undefined;
        this.default_assumption_id = undefined;
        this.default_assumption_name = '';
        this.name = '';

        this.created_at = new Date();
        this.updated_at = new Date();
    }
}